export interface ProviderOptions {
    portis: any;
}
